import { render, staticRenderFns } from "./CollectionUnit.vue?vue&type=template&id=0f4dbf10&scoped=true"
import script from "./CollectionUnit.vue?vue&type=script&lang=js"
export * from "./CollectionUnit.vue?vue&type=script&lang=js"
import style0 from "./CollectionUnit.vue?vue&type=style&index=0&id=0f4dbf10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4dbf10",
  null
  
)

export default component.exports